// ------------------------------------
// props 輸入需求 :
// props.date : object
// props.data : object : { data: array }            ( sleep Qualities )
// ------------------------------------

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import comm_imgs from '../../../../comm_imgs';
import Account from '../../../../actions/Account';

const SleepPieChart =(props)=>{
    const {t} = useTranslation()
    // chart related
    let data = props.data

    const [SE, setSE] = useState({
        chart:{ type: 'pie', },
        series:[]
    });
    useEffect(()=>{
        let _SE_arr = process_data_to_arr(data)
        setSE({
            chart:{ type: 'pie', backgroundColor:"rgba(0,0,0,0)" },
            title: { text: '' },
            exporting: {enabled: false},
            legend: {
                align: 'left',
                verticalAlign: 'middle',
                itemMarginBottom: 25,
                itemStyle: { fontSize: '16px', fontWeight: 'normal', },
                // backgroundColor: '#FFFFFF',
            },
            plotOptions: {
                series: { animation: false },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            let _time = Math.round(this.y/60)
                            let _min = _time%60
                            let _hr = parseInt(_time/60)%60
                            // return "【"+ this.key +"】<br />"+
                            return "<b>"+ this.key +"</b><br />"+
                                +_hr+t("GLOBAL.UNIT.HOURS")+_min+t("GLOBAL.UNIT.MINUTE")
                        },
                        width:500,
                        style: { fontWeight: 'normal', fontSize:"12px" },
                        borderRadius: 5,
                        backgroundColor: 'rgba(255,255,255,75%)',
                        distance: 10,
                    },
                    // showInLegend: true
                }
            },
            tooltip: {
                formatter: function(){return '<b>'+this.point.name +'</b><br/>' + secToTime(this.y)}
            },
            series:[{
                colors:["#71DFE7","#FFE652","rgba(180, 180, 180, 1)"],
                name:t("HISTORY_RECORD.RECENT"),
                colorByPoint:true,
                innerSize:'40%',
                size:"80%",
                data:_SE_arr[0],
                zIndex: 2
            },
        ]
        })
    }, [data, t])

    function process_data_to_arr(_data){
        let _arr = []
        let _avg_arr = []
        _arr.push({
            name:t("HISTORY_RECORD.TOTAL_SLEEPING_TIME"),
            y:parseInt(_data.total_sleep_time),
        })
        _arr.push({
            name:t("HISTORY_RECORD.SLEEP_LATENCY"),
            y:parseInt(_data.total_sleep_latency),
        })
        _arr.push({
            name:t("HISTORY_RECORD.NIBTTOTAL"),
            y:parseInt(_data.total_NIB_time),
        })
        _avg_arr.push({
            name:t("HISTORY_RECORD.AVG_SLEEP_TIME"),
            y:parseInt(_data.average_total_sleep_time),
        })
        _avg_arr.push({
            name:t("HISTORY_RECORD.AVG_SLEEP_LATENCY"),
            y:parseInt(_data.average_total_sleep_latency),
        })
        _avg_arr.push({
            name:t("HISTORY_RECORD.AVG_NIB_TOTAL"),
            y:parseInt(_data.average_total_NIB_time),
        })
        return [_arr, _avg_arr]
    }
    function translate_time_format(date){
        let _date = new Date(date)
        return (date!=="None")? `${_date.getMonth()+1}/${_date.getDate()} ${addZero(_date.getHours())}:${addZero(_date.getMinutes())}`:"-"
    }
    function addZero(time){ return (time/10>=1)? time:"0"+time }
    function secToTime(y) {
        let _time = Math.round(y/60)
        let _min = _time%60
        let _hr = parseInt(_time/60)%60
        return _hr + t("GLOBAL.UNIT.HOURS") + ' ' + _min + t("GLOBAL.UNIT.MINUTE")
    }
    function calculateAlert(_rec, _avg, _func){
        let _percentage = Math.round(100*(parseInt(_rec)-parseInt(_avg))/parseInt(_avg))
        if(parseInt(_avg)===0){return _func(_rec)}
        if(_percentage>10){
            if(_avg===0){return _func(_rec)}
            return <div className='red_font fx-d-c fx-ccc'>{_func(_rec)}<div className='font-m'>({t("HISTORY_RECORD.OVER")}{_percentage}%)</div></div>
        }
        else if(_percentage<-10){return <div className='red_font fx-d-c fx-ccc'>{_func(_rec)}<div className='font-m'>({t("HISTORY_RECORD.LESS")}{_percentage}%)</div></div>}
        else{ return _func(_rec) }
    }

    if(Account.isMobileOrTablet()){return (
    <div className="fx-d-c fx-fsfs SEBack HSmobile">
        {data.SE===undefined? <div className='w-100 h-100 font-ml fx-ccc'>{t("GLOBAL.NO_DATA")}</div>:<>
        <div className='fx-d-r fx-cspar w-100'>
            <div className='fx-d-c fx-ccc w-40'>
                <div className='SE font-l'> {data.SE===undefined?"-":Math.round(data.SE)}%</div>
                <div>{t("HISTORY_RECORD.SLEEP_EFFICIENCY")}</div>
            </div>
            <div className='fx-d-c fx-cspar w-100 w-60'>
                <div><img alt="se in bed" className='w-m30px h-m30px' src={comm_imgs.ICON_SE_INBED} /> : {translate_time_format(data.start_time)}</div>
                <div><img alt="se wake up" className='w-m30px h-m30px' src={comm_imgs.ICON_SE_WAKEUP} /> : {translate_time_format(data.end_time)}</div>
            </div>
        </div>

        <div className='SEcontent w-100 h-100 fx-d-c fx-cspar font-m bboder'>
            <div className='w-100 fx-d-r fx-ccc'>
                <div className='w-40 fx-ccc'>{t("HISTORY_RECORD.TOTAL_SLEEPING_TIME")}</div>
                <div className='w-60 font-ml bold fx-ccc'> {secToTime(data.total_sleep_time)}</div>
            </div>
            <div className='w-100 fx-d-r fx-ccc'>
                <div className='w-40 fx-ccc'>{t("HISTORY_RECORD.SLEEP_LATENCY")}</div>
                <div className='w-60 font-ml bold fx-ccc'> {secToTime(data.total_NIB_time)}</div>
            </div>
            <div className='w-100 fx-d-r fx-ccc'>
                <div className='w-40 fx-ccc'>{t("HISTORY_RECORD.RECENT_NIGHT")}{t("HISTORY_RECORD.NIB_FOR")}</div>
                <div className='font-ml w-60 fx-ccc bold'>{data.NIB_num}{t("GLOBAL.UNIT.TIMES")}</div>
            </div>
            <div className='w-100 fx-d-r fx-ccc'>
                <div className='w-40 fx-ccc'>{t("HISTORY_RECORD.RECENT_NIGHT")}{t("HISTORY_RECORD.ROLL_FOR")}</div>
                <div className='font-ml w-60 fx-ccc bold pad-5 b l r'>{data.turn_over_num}{t("GLOBAL.UNIT.TIMES")}</div>
            </div>
        </div></>}
    </div>
    )}
    else{return (
    <div className="fx-d-c fx-fsfs min-h300 w-100 SEBack margb-10">
        <div className='w-100 h-100 fx-d-r'>
            <div className='w-30 h-100 fx-d-c fx-ccc'>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={SE}
                    containerProps={{ className: "w-100 h-100" }}
                />
                {/* <div className="font-l">{t("HISTORY_RECORD.SLEEP_EFFICIENCY")}</div> */}
            </div>
            <div className='w-20 fx-d-c fx-ccc'>
                <div className='SE'> {data.SE===undefined?"-":Math.round(data.SE)}%</div>
                <div>{t("HISTORY_RECORD.SLEEP_EFFICIENCY")}</div>
            </div>
            {data.SE===undefined? <div className='font-l fx-ccc'>
                    {props.date.getDate() === new Date().getDate() && new Date().getHours()<12? t("HISTORY_RECORD.SLEEP_DATA"):t("GLOBAL.NO_DATA")}
                </div>
            :<div className='w-50 h-100 fx-d-c fx-cspar font-m bboder'>
                <div className='fx-d-r h-25 w-100 fx-cspar font-ml bold'>
                    <div><img alt="se in bed" className='w-30px h-30px' src={comm_imgs.ICON_SE_INBED} /> : {translate_time_format(data.start_time)}</div>
                    <div><img alt="se wake up" className='w-30px h-30px' src={comm_imgs.ICON_SE_WAKEUP} /> : {translate_time_format(data.end_time)}</div>
                </div>
                <div className='fx-d-r h-50 w-100 fx-cspar'>
                    <div className='w-50 fx-d-c fx-ccc'>
                        <div className='font-ml bold'> {secToTime(data.total_sleep_time)}</div>
                        <div className=''>{t("HISTORY_RECORD.TOTAL_SLEEPING_TIME")}</div>
                    </div>
                    <div className='w-50 fx-d-c fx-ccc'>
                        <div className='font-ml bold'> {calculateAlert(data.total_sleep_latency, data.average_total_sleep_latency, secToTime)}</div>
                        <div className=''>{t("HISTORY_RECORD.SLEEP_LATENCY")}</div>
                    </div>
                </div>
                <div className='fx-d-r h-25 w-100 fx-ccc font-m'>
                    <div className='w-50 fx-d-r fx-ccc'>{t("HISTORY_RECORD.RECENT_NIGHT")} {t("HISTORY_RECORD.NIB_FOR")}
                        <div className='font-ml bold pad-5 b l r'>
                            {calculateAlert(data.NIB_num, data.average_NIB_num, (a)=>{return a})}
                        </div>{t("GLOBAL.UNIT.TIMES")}
                    </div>
                    {/* 當晚翻身 */}
                    <div className='w-50 fx-d-r fx-ccc'>{t("HISTORY_RECORD.RECENT_NIGHT")} {t("HISTORY_RECORD.ROLL_FOR")}
                        {/* <div className='font-ml bold pad-5 b l r'>{calculateAlert(data.turn_over_num, data.average_turn_over_num, (a)=>{return a})}</div>{t("GLOBAL.UNIT.TIMES")} */}
                        <div className='font-ml bold pad-5 b l r fx-d-c fx-ccc'>{data.turn_over_num}</div>{t("GLOBAL.UNIT.TIMES")}
                    </div>
                </div>
            </div>}
        </div>
    </div>
    )}
}
export default SleepPieChart;